// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"5da9d9c8","737":"cc79c0e3","799":"5da9d9c8"}[chunkId] + ".chunk.css";
};